/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect} from 'react';
// redux
import {useSelector, useDispatch} from 'react-redux';
// material
import {Group, DateRangePickerDropDown, ListSelectDropDown} from '@insticator/insticator-ui';

// utils
import {countries} from '@insticator/insticator-ui'; // iui-utils
import {transpileDataForFilters} from '../../utils/transpilers/transpileDataForFilters';
import {getSiteAndAppFilterName} from "../../utils/filterhelpers";
import { formatDateToYYYYMMDD, getRevenueAvailableDate, dateStringToDateWithCurrentTime } from "../../utils/date";
// actions
import {setFilter} from '../../state/slices/app';
// styles
import injectSheet from 'react-jss';
import styles from './globalfilter_styles';


/* ========== ~~~~~~~~~~ GLOBAL APPLICATION FILTERS ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => {
    // component props
    const {onFilterApply} = props;

    // redux state
    const sidebarOpen = useSelector(state => state.app.sidebarOpen)
    const sitesAndApps = useSelector((state) => state.account.sitesAndApps)
    const selectedDateRange = useSelector((state) => state.app.filters.dateRange)
    const selectedComparisonType = useSelector((state) => state.app.filters.compareTo)
    const selectedDevices = useSelector((state) => state.app.filters.devices)
    const selectedCountries = useSelector((state) => state.app.filters.countries)
    const selectedSites = useSelector((state) => state.app.filters.sites)
    const selectedSitesByType = useSelector((state) => state.app.filters.sitesByType)

    // actions
    const dispatch = useDispatch();
    const onFilterChange = ({filter, value}) => {
        if (filter === 'dateRange') {

            // if the date range selects unavailable date, set it to the available date
            if (value.from && dateStringToDateWithCurrentTime(value.from) > getRevenueAvailableDate()) {
                value.from = formatDateToYYYYMMDD(getRevenueAvailableDate())
            }

            // if the date range selects unavailable date, set it to the available date
            if (value.to && dateStringToDateWithCurrentTime(value.to) > getRevenueAvailableDate()) {
                value.to = formatDateToYYYYMMDD(getRevenueAvailableDate())
            }
        }
        return dispatch(setFilter({filter, value}))
    };

    const handleFilterApply = ({filter, value}) => {
        onFilterApply()
        // dispatch(setFilter({filter, value}))
    };

    useEffect(() => {
    }, [selectedSites]);
    const getDevices = () => {
        return [
            {value: 'DESKTOP', name: 'Desktop', selected: selectedDevices.indexOf('DESKTOP') >= 0},
            {value: 'MOBILE', name: 'Mobile Web', selected: selectedDevices.indexOf('MOBILE') >= 0}
        ]
    }

    const getDisabledDates = () => [{
        after: getRevenueAvailableDate()
    }]

    return (
        <div id="globalfilter" className={`${props.classes.globalFilter} sidebarOpen-${sidebarOpen}`}>
            <Group name={'filters'}>
                <ListSelectDropDown
                    klass={`filter-site`}
                    name={getSiteAndAppFilterName(sitesAndApps)}
                    // icon={`link`}
                    items={transpileDataForFilters(sitesAndApps, true, true)}
                    selected={selectedSites.length ? selectedSitesByType : null}
                    noEmptyApply={true}
                    buttonAction={
                        sitesAndApps => {
                            onFilterChange({
                                filter: 'sites',
                                value: Object.values(sitesAndApps).flat()
                            })
                            onFilterChange({
                                filter: 'sitesByType',
                                value: sitesAndApps
                            })
                        }
                    }
                />
                <ListSelectDropDown
                    klass={`filter-device`}
                    name={selectedDevices.length === 1 ? 'Device' : 'Devices'}
                    // icon={`mobile-alt`}
                    items={getDevices()}
                    noEmptyApply={true}
                    buttonAction={
                        devices => {
                            onFilterChange({
                                filter: 'devices',
                                value: devices[undefined]
                            })
                        }
                    }
                />
                <ListSelectDropDown
                    klass={`filter-country`}
                    name={selectedCountries.length === 1 ? 'Country' : 'Countries'}
                    // icon={`globe`}
                    items={transpileDataForFilters(countries, false, true)}
                    // undefined creates correct structure for ListSelectDropDown
                    selected={selectedCountries.length ? {undefined: selectedCountries} : null}
                    noEmptyApply={true}
                    buttonAction={
                        countries => onFilterChange({
                            filter: 'countries',
                            // undefined gets correct structure back from structure of selected returned from ListSelectDropDown
                            value: countries[undefined]
                        })
                    }
                />
            </Group>
            <DateRangePickerDropDown
                klass={`filter-date`}
                indicatorTitle={'Date range'}
                hideButtons={false}
                showShortcuts={true}
                showShortcutTextInPreview={true}
                customDateRanges={false}
                use4PMLogic={true}
                range={selectedDateRange}
                updateRange={
                    range => onFilterChange({
                        filter: 'dateRange',
                        value: range
                    })
                }
                compareType={selectedComparisonType}
                changeCompareType={
                    comparisonType => onFilterChange({
                        filter: 'compareTo',
                        value: comparisonType
                    })
                }
                handleApply={
                    range => handleFilterApply({
                        filter: 'dateRange',
                        value: range
                    })
                }
                disabledDays={getDisabledDates()}
            />
        </div>
    );
});
